import { connect } from 'react-redux'
import NavigationWrapper from '../../layouts/shared-navigation/navigation-wrapper'

export default connect(
  state => ({ overlay: state.navigation.sideNav }),
  () => ({})
)(NavigationWrapper)
